import { IHideLoaderAction } from "../interfaces/loader.interface";

export function hideLoader(): IHideLoaderAction {
  return {
    type: "HIDE_LOADER",
  };
}
